export default {
  prefix: '',
  suffix: '',
  thousands: ',',
  decimal: '.',
  precision: 0,
  allowDecimal: false,
}